// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"10":"dce17b90","241":"dce17b90","260":"dce17b90","313":"dce17b90"}[chunkId] + ".chunk.css";
};